import React, { useEffect } from "react";
import { Route, Switch } from "react-router";
import { Provider } from "react-redux";
import { ConnectedRouter } from "react-router-redux";

import GA from "helpers/ga";
import store from "../../reduxStore";
import history from "../../history";
import { URLS } from "constants/urlConstants";
import IntlConnector from "../../intlConnector";
import { configurationsFromFile } from "../../apiUtils";
import {
  CallbackPage,
  AuthErrorPage,
  MyReports,
  Settings,
  AllNotifications,
  DeliveryNotes,
  MyDeliveries,
  DeliveryPreferences,
  OrderDetails,
  InvoiceDetails,
  AccountStatements,
  DeliveryDetails,
  Deliveries,
  ReceiptsReturns,
  InspectionReport,
  QualityReport,
  ServiceAndSupport,
  NewCultivationAdvice,
  MyCultivationAdvice,
  NewNotification,
  CultivationAdvice,
  MyNotifications,
  PrivacyStatement,
  PdfViewer,
  Dashboard,
  AuthRoute,
  Orders,
  Invoices,
  CustomerComplaints,
  AreaStatementView,
  AreaStatementCreate,
  AreaStatementSpring,
  AreaStatementLelie,
  AreaStatementZant,
  CompanyInformation,
  CompanyInformationEdit,
} from "../index";

const Routes: React.FC = () => {
  useEffect(() => {
    GA.initializeAnalytics();
    configurationsFromFile();
  }, []);
  /**
   * Most specific route on top
   */
  return (
    <Provider store={store}>
      <IntlConnector>
        <ConnectedRouter history={history}>
          <Switch>
            <Route path={URLS.AUTH_CALLBACK_URL} component={CallbackPage} />
            <Route path={URLS.AUTH_ERROR_URL} component={AuthErrorPage} />
            <AuthRoute path={URLS.MY_REPORTS_URL} component={MyReports} />
            <AuthRoute
              path={URLS.CULTIVATION_ADVICE_URL}
              component={CultivationAdvice}
            />
            <AuthRoute path={URLS.SETTINGS_URL} component={Settings} />
            <AuthRoute
              path={URLS.ALL_NOTIFICATIONS_URL}
              component={AllNotifications}
            />
            <AuthRoute
              path={URLS.DELIVERY_NOTES_URL}
              component={DeliveryNotes}
            />
            <AuthRoute path={URLS.MY_DELIVERIES_URL} component={MyDeliveries} />
            <AuthRoute
              path={URLS.DELIVERIES_PREFERENCES}
              component={DeliveryPreferences}
            />
            <AuthRoute
              path={`${URLS.ORDERS_URL}/:id`}
              component={OrderDetails}
            />
            <AuthRoute path={URLS.ORDERS_URL} component={Orders} />
            <AuthRoute
              path={`${URLS.INVOICES_URL}/:id`}
              component={InvoiceDetails}
            />
            <AuthRoute path={URLS.INVOICES_URL} component={Invoices} />
            <AuthRoute
              path={URLS.ACCOUNT_STATEMENTS_URL}
              component={AccountStatements}
            />
            <AuthRoute
              path={`${URLS.DELIVERIES_URL}/:id`}
              component={DeliveryDetails}
            />
            <AuthRoute path={URLS.DELIVERIES_URL} component={Deliveries} />
            <AuthRoute
              path={URLS.RECEIPTS_RETURNS_URL}
              component={ReceiptsReturns}
            />
            <AuthRoute
              path={URLS.INSPECTION_REPORT_URL}
              component={InspectionReport}
            />
            <AuthRoute
              path={URLS.QUALITY_REPORT_URL}
              component={QualityReport}
            />
            <AuthRoute
              path={URLS.SERVICE_AND_SUPPORT_URL}
              component={ServiceAndSupport}
            />
            <AuthRoute
              path={URLS.USER_MANUALS_URL}
              component={ServiceAndSupport}
            />
            <AuthRoute path={URLS.CONTACT_URL} component={ServiceAndSupport} />
            <AuthRoute
              path={`${URLS.MY_CULTIVATION_ADVICE_URL}/new`}
              component={NewCultivationAdvice}
            />
            <AuthRoute
              path={`${URLS.MY_CULTIVATION_ADVICE_URL}/:id`}
              component={NewCultivationAdvice}
            />
            <AuthRoute
              path={URLS.MY_CULTIVATION_ADVICE_URL}
              component={MyCultivationAdvice}
            />
            <AuthRoute
              path={`${URLS.MY_NOTIFICATIONS_URL}/new`}
              component={NewNotification}
            />
            <AuthRoute
              path={`${URLS.MY_NOTIFICATIONS_URL}/:id`}
              component={NewNotification}
            />
            <AuthRoute
              path={URLS.MY_NOTIFICATIONS_URL}
              component={MyNotifications}
            />
            <AuthRoute
              path={URLS.PRIVACY_STATEMENT}
              component={PrivacyStatement}
            />
            <AuthRoute
              path={URLS.CUSTOMER_COMPLAINTS}
              component={CustomerComplaints}
            />
            <AuthRoute
              path={URLS.AREA_STATEMENT_INFO_URL}
              component={AreaStatementView}
            />
            <AuthRoute
              path={URLS.AREA_STATEMENT_CREATE_URL}
              component={AreaStatementCreate}
            />
            <AuthRoute
              path={URLS.AREA_STATEMENT_SPRING}
              component={AreaStatementSpring}
            />
            <AuthRoute
              path={URLS.AREA_STATEMENT_LELIE}
              component={AreaStatementLelie}
            />
            <AuthRoute
              path={URLS.AREA_STATEMENT_ZANT}
              component={AreaStatementZant}
            />
            <AuthRoute
              path={URLS.COMPANY_INFORMATION}
              component={CompanyInformation}
            />
            <AuthRoute
              path={URLS.COMPANY_INFORMATION_EDIT}
              component={CompanyInformationEdit}
            />
            {/*<AuthRoute*/}
            {/*  path={`${URLS.OPEN_DOCUMENT}/:id`}*/}
            {/*  component={PdfViewer}*/}
            {/*  withoutLayout*/}
            {/*/>*/}
            <Route
              path={`${URLS.OPEN_DOCUMENT}/:id`}
              component={PdfViewer}
              withoutLayout
            />
            <AuthRoute to={URLS.HOME_URL} component={Dashboard} />
            {/* <Redirect to={URLS.HOME_URL} /> */}
          </Switch>
        </ConnectedRouter>
      </IntlConnector>
    </Provider>
  );
};

export default Routes;
